/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Agent_LinkInputs */

const en_directory_submit_agent_link = /** @type {(inputs: Directory_Submit_Agent_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How the agent flow works`)
};

const zh_directory_submit_agent_link = /** @type {(inputs: Directory_Submit_Agent_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解 Agent 提交流程`)
};

/**
* | output |
* | --- |
* | "How the agent flow works" |
*
* @param {Directory_Submit_Agent_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_agent_link = /** @type {((inputs?: Directory_Submit_Agent_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Agent_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_agent_link(inputs)
	return zh_directory_submit_agent_link(inputs)
});
export { directory_submit_agent_link as "directory.submit.agent_link" }